/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Leaderboard_TitleInputs */

const fr_admin_leaderboard_title = /** @type {(inputs: Admin_Leaderboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classement`)
};

/**

* @param {Admin_Leaderboard_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_leaderboard_title = /** @type {((inputs?: Admin_Leaderboard_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Leaderboard_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_leaderboard_title(inputs)
});